import { gql } from '@apollo/client';
import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';

export const GET_METER_ADDONS_QUERY = gql`
  query getAddons {
    meterAddons {
      data {
        id
        attributes {
          name
          code
        }
      }
    }
  }
`;

export type MeterAddonsForSelect = Pick<SerializedMeterAddon, 'name' | 'code'> & { id: string };

export interface GetMeterAddonsQueryResult {
  meterAddons: {
    data: MeterAddonsForSelect[];
  };
}
